import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  DestroyRef,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef,
  createNgModule,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';

import type { MiniCartSuggestionComponent as OriginalComponent } from '../../shared/mini-cart-suggestion/mini-cart-suggestion.component';

@Component({
  selector: 'custom-lazy-mini-cart-suggestion',
  standalone: false,
  templateUrl: './lazy-mini-cart-suggestion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyMiniCartSuggestionComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/cross-selling-popup/shared/mini-cart-suggestion/mini-cart-suggestion.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;

  private component: ComponentRef<OriginalComponent>;
  private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.featureToggleService
      .enabled$('crossSellingPopup')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async enabled => {
        if (enabled) {
          await this.renderComponent();
        } else {
          this.anchor.clear();
        }
      });
  }

  private async renderComponent() {
    const module = await import(`../../cross-selling-popup.module`).then(m => m.CrossSellingPopupModule);

    const { MiniCartSuggestionComponent: originalComponent } =
      await import('../../shared/mini-cart-suggestion/mini-cart-suggestion.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });

    this.component.changeDetectorRef.markForCheck();
  }
}
